<template>
  <responsive-drawer-header :color="color" :moduleUnreadCount="updateHint > 0 ? currentInstanceUnreadCount : null" :isItemDisplayed="!!displayedDocument">
    <template v-slot:drawer-module-title> {{ mx_moduleTitle }}</template>
    <template v-slot:drawer-subtitle>
      <!--      <div v-if="pathResolved !== ''">{{ pathResolved }}</div>-->
      <!--      <div v-else>{{ $t('document.inModuleRoot') }}</div>-->

      <!--      <div v-if="!xs" class="right-center"></div>-->
    </template>
    <template v-slot:drawer-command-slot>
      <sort-menu
        v-if="displayDocumentSorters"
        v-model="sorterName"
        :displayCockpitSorters="displayCockpitSorters"
        :color="theme.appBar.other.color"
      ></sort-menu>
    </template>

    <template v-slot:left-module-title>{{ mx_moduleTitle }}</template>
    <template v-slot:left-subtitle>
      <div class="hidden-update-marker">{{ updateHint }}</div>
      <div v-if="displayedDocument && displayedDocument.title">{{ displayedDocument.title }}</div>
      <div v-else-if="displayedDocument && displayedDocument._displayLocation">
        {{ $t('document.withinFolder') }}&nbsp;<b>{{ displayedDocument._displayLocation.slice(0, -1) }}</b>
      </div>

      <div class="caption" v-else-if="displayedDocument">{{ $t('document.inModuleRoot') }}</div>
      <div class="d-flex caption" v-else-if="dataLoaded">{{ $t('document.info.selected.none') }}</div>
    </template>

    <template v-slot:right>
      <v-btn v-if="hasLandingImage && $route.params.documentId" icon :color="color" @click="backToParentFolder"><v-icon>mdi-arrow-left</v-icon></v-btn>
      <label-group
        v-if="labelsByInstance.length > 0"
        class="ml-6 touch"
        v-model="selectedLabelId"
        display-property="label"
        :labels="labelsByInstance"
      ></label-group>
      <div v-if="displayedDocument || hasUnreadItems" class="d-flex align-center">
        <div style="width: 20px"></div>
        <acknowledge-button
          v-if="displayedDocument && !xs && isToAcknowledge"
          :document="displayedDocument"
          :documentTitle="displayedDocument.title"
          :moduleType="moduleType"
          :color="color"
        ></acknowledge-button>
        <toggle-read-button v-if="!isToAcknowledge && displayedDocument && !smAndDown" :item="displayedDocument" :color="color"></toggle-read-button>
        <favorite-icon v-if="!isToAcknowledge && displayedDocument && !smAndDown" :item="displayedDocument" :color="color"></favorite-icon>

        <v-menu style="min-width: 250px" left bottom close transition="slide-y-transition" offset-y dense close-on-click close-on-content-click>
          <template v-slot:activator="{ on, attrs }">
            <v-btn :color="color" fab class="d-flex" icon v-bind="attrs" v-on="on">
              <v-icon>mdi-dots-vertical</v-icon>
            </v-btn>
          </template>

          <v-list style="min-width: 300px">
            <mark-all-as-read-button listItem v-if="hasUnreadItems" @onMarkAllAsRead="$store.commit('documents/setReadAllDialogOpen', { value: true })">
            </mark-all-as-read-button>

            <download
              v-if="displayedDocument && features.enableDocumentDownload !== false"
              listItem
              :fileName="displayedDocument.title"
              :downloadUrl="documentUrl"
              :color="color"
            ></download>
            <!-- if the document needs quittierung we display the button always in menu-->
            <favorite-icon v-if="isToAcknowledge || (displayedDocument && smAndDown)" listItem :item="displayedDocument"></favorite-icon>
            <share-button v-if="displayedDocument" listItem :file="displayedDocument" :moduleBackendId="moduleBackendId" :color="color"></share-button>
            <!-- if the document needs quittierung we display the button always in menu-->
            <toggle-read-button v-if="isToAcknowledge || (displayedDocument && smAndDown)" listItem :item="displayedDocument" :color="color">
            </toggle-read-button>
            <acknowledge-button
              listItem
              v-if="displayedDocument && !mdAndUp && isToAcknowledge"
              :documentTitle="displayedDocument.title"
              :document="displayedDocument"
              :moduleType="moduleType"
            >
            </acknowledge-button>
          </v-list>
        </v-menu>

        <read-all-dialog :instance="instance" :folder="currentFolder" namespace="documents"></read-all-dialog>
      </div>
    </template>
  </responsive-drawer-header>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import utils from '@/common/utils';
import FavoriteIcon from '@/components/buttons/FavoriteIcon';
import common from '@/mixins/common';
import configMixin from '@/mixins/configMixin';
import module from './index';
import Download from '@//components/buttons/Download.vue';
import ShareButton from '@/components/buttons/ShareButton.vue';
import ToggleReadButton from '@/components/buttons/ToggleReadButton.vue';
import AcknowledgeButton from '@/components/buttons/AcknowledgeButton.vue';
import MarkAllAsReadButton from '@/components/buttons/MarkAllAsReadButton.vue';
import ResponsiveDrawerHeader from '@/layouts/ResponsiveDrawerHeader.vue';
import ReadAllDialog from '@/dialogs/ReadAllDialog';
import acknowledgeService from '@/services/acknowledgeService';
import SortMenu from '@/components/menus/SortMenu';
import index from '@/modules/document/index';
import LabelGroup from '@/components/groups/LabelGroup.vue';

const ROOT = { root: true };

export default {
  name: 'DocumentHeader',
  mixins: [common, configMixin],
  components: {
    LabelGroup,
    // MorphIcon,
    FavoriteIcon,
    Download,
    ShareButton,
    ToggleReadButton,
    AcknowledgeButton,
    MarkAllAsReadButton,
    ResponsiveDrawerHeader,
    ReadAllDialog,
    SortMenu,
  },
  data() {
    return {
      showLabels: false,
      showConfirmReadAllDialog: false,
      currentInstanceUnreadCount: 0,
      selectedLabelId: null,
    };
  },

  mounted() {
    this.$store.commit(`documents/setSortFiles`, false); // sort by importance
    if (this.dataLoaded) {
      this.currentInstanceUnreadCount = this.getCurrentInstanceUnreadCount();
    }
    this.selectedLabelId = this.$route.query?.labelId ? parseInt(this.$route.query.labelId) : null;
  },

  computed: {
    ...mapState('documents', [
      'dataLoaded',
      'fileBrowserPath',
      'instanceFolderTrees',
      'foldersById',
      'documentsById',
      'displayedDocumentId',
      'sortFiles',
      'updateHint',
      'labelsMapping',
    ]),
    ...mapGetters({
      displayedDocumentName: 'documents/getDisplayedDocumentTitle',
    }),
    moduleType: () => module.moduleType,
    moduleBackendId: () => module.api,
    instance() {
      return `${this.$route.params.instance}`;
    },
    labelsByInstance() {
      return this.$store.state.documents.labels
        .filter((label) => label.instance == this.$route.params.instance && this.usedLabelIds.includes(label.id))
        .sort((a, b) => a.sort - b.sort); // use == not === because == converts the variable values to the same type before performing comparison. This is called type coercion.
    },
    usedLabelIds() {
      const labelIds = [];
      if (this.labelsMapping && Array.isArray(this.labelsMapping)) {
        this.labelsMapping.forEach((m) => {
          if (!labelIds.includes(m.labelIdFk)) {
            if (this.documentsById[m.fileIdFk]) {
              if (this.documentsById[m.fileIdFk]?.instance == this.$route.params.instance) {
                labelIds.push(m.labelIdFk);
              }
            }
          }
        });
      }
      return labelIds;
    },
    currentFolder() {
      if (this.fileBrowserPath && this.fileBrowserPath.length > 0) {
        let currentFolderId = this.fileBrowserPath[this.fileBrowserPath.length - 1];
        return this.foldersById[currentFolderId];
      }
      return null;
    },
    color() {
      return this.theme.appBar.other.color;
    },

    hasUnreadItems() {
      return this.currentInstanceUnreadCount > 0;
    },
    documentRoot() {
      return this.$store.state.documents.instanceFolderTrees[this.$route.params.instance]
        ? this.$store.state.documents.instanceFolderTrees[this.$route.params.instance]
        : [];
    },
    displayedDocument() {
      return this.$store.state.documents.documentsById[this.displayedDocumentId];
    },

    isToAcknowledge() {
      return acknowledgeService.isToAcknowledge(this.displayedDocument);
    },

    documentUrl() {
      if (this.displayedDocument) {
        return utils.constructFileUrlNoCaching(this.moduleBackendId, this.displayedDocument, 'filename');
      }
      return null;
    },
    displayCockpitSorters() {
      return this.moduleConfig.displayCockpitSorters || false;
    },
    displayDocumentSorters() {
      return this.moduleConfig.displayDocumentSorters !== undefined ? this.moduleConfig.displayDocumentSorters : true;
    },
    sorterName: {
      get() {
        // return this.$store.state.documents.sorterName;
        let sorterName = this.$store.state.documents.documentSorterNamesByInstance[this.instance];
        console.debug(`sorterName for instance=${this.instance}=`, sorterName);
        return sorterName;
      },
      set(value) {
        console.debug('sorterName', value);
        this.showUnreadOnly = false;
        // this.$store.commit('documents/setSorterName', value);
        this.$store.commit('documents/setInstanceSorterName', { instance: this.instance, sorterName: value });
      },
    },
    displaySideNavigation() {
      const config = this.getModuleConfig(module.moduleType, this.instance);
      return config.hasSideNavigation && !this.smAndDown; // does 'hasSideNavigation' exist?
    },
    displayDocument() {
      return this.documentsById[this.displayedDocumentId];
    },
    moduleConfig() {
      return this.getModuleConfig(index.moduleType, this.$route.params.instance);
    },
    hasLandingImage() {
      return this.moduleConfig.hasLandingImage;
    },
  },
  methods: {
    acknowledge() {
      let sendboxTitle = this.$t('action.acknowledge.msg', { object: this.displayedDocument.title });
      let snackbarText = sendboxTitle;

      this.$store.dispatch(
        `sendbox/markAsAcknowledged2`,
        {
          item: this.displayedDocument,
          sendboxTitle,
          snackbarText,
        },
        ROOT
      );
    },
    getCurrentInstanceUnreadCount() {
      let { instance } = this.$route.params;
      let unreadCount = this.$store.getters[`documents/getUnreadCountByModuleInstance`](instance);
      console.debug('currentInstanceUnreadCount instance', instance, unreadCount);
      return unreadCount;
    },
    backToParentFolder() {
      const parentFolderId = this.displayDocument.folderIdFk;
      this.$store.dispatch('documents/setDisplayedDocumentId', { documentId: null });
      this.$router.push({ name: 'documentFolder', params: { instance: this.$route.params.instance, folderId: parentFolderId } });
    },
  },
  watch: {
    selectedLabelId(newValue) {
      this.$router.push({ query: { labelId: newValue } });
    },
    updateHint(newValue) {
      console.debug('updateHint changed', newValue);
      this.currentInstanceUnreadCount = this.getCurrentInstanceUnreadCount();
    },
    dataLoaded(newValue) {
      console.debug('dataLoaded changed', newValue);
      this.currentInstanceUnreadCount = this.getCurrentInstanceUnreadCount();
    },
  },
};
</script>
